<div class="page-container">
  
  <mat-card>
    <h1 style="padding-top: 5px; text-align: center; font-weight: bolder; font-size: 30px; color:#0d4794;"> Welcome </h1>

    <div>
      
    </div>
            <mat-card style="margin:20px; margin-bottom: 80px;">

              <mat-card class="example-card">
                <mat-card-header>
                  
                  <mat-card-title style="font-weight: bold;">
                    Prof Lourens van Staden
                  </mat-card-title>
                  
                </mat-card-header>
                <img mat-card-image src="https://dh2dlbjd2qx17.cloudfront.net/img/ProfVanStaden1x1.jpg" alt="Photo of a Shiba Inu" class="staden">
                <mat-card-content>
                 
                  <p> Vice-Chancellor and Principal</p>
                  
        
                </mat-card-content>
                

              </mat-card>
              <br>
              <h2>Welcome to the Tshwane University of Technology</h2>


           
          </mat-card>

  </mat-card>
</div>

